import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type StarIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const StarIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: StarIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24.01 24.01"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73628 20.8377C7.22921 21.1024 6.61577 21.0558 6.1545 20.7176C5.69323 20.3793 5.46437 19.8083 5.56438 19.2451L6.37372 14.6061L2.9663 11.3408C2.5498 10.9436 2.39716 10.3432 2.57339 9.7953C2.74963 9.24742 3.22368 8.8486 3.79364 8.76871L8.52461 8.09243L10.6605 3.83166C10.9137 3.32067 11.4348 2.99739 12.0051 2.99739C12.5754 2.99739 13.0964 3.32067 13.3496 3.83166L15.4855 8.09243L20.2165 8.76871C20.7864 8.8486 21.2605 9.24742 21.4367 9.7953C21.613 10.3432 21.4603 10.9436 21.0438 11.3408L17.6364 14.6061L18.4457 19.2461C18.5458 19.8093 18.3169 20.3803 17.8556 20.7186C17.3944 21.0568 16.7809 21.1034 16.2738 20.8387L12.0051 18.6328L7.73628 20.8377Z"
        stroke={color}
        strokeWidth={1.59167}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
